import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        <div className="py-20 bg-white text-center">
           <h1 className="text-6xl font-black text-brand-black mb-4">Start the Conversation</h1>
           <p className="text-xl text-gray-500 max-w-2xl mx-auto">We work with a select number of clients each year. Reach out to see if we're a match.</p>
        </div>
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;